<template>
  <div class="item-content">
    {{datamodel.value}}
  </div>
</template>

<script>

export default {
  uuid: "00000000-0000-0000-0000-000000000010",
  components: {},
  props: [
    'datamodel',
  ],
  data() {
    return {
      
    }
  },
  computed: {
    
  },
  methods: {
    
  },
  created() {},
  mounted() {

  }
}
</script>
<style lang="scss">


</style>
